"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    SEARCH_ENDPOINT: process.env.SEARCH_ENDPOINT ??
        process.env.GATSBY_SEARCH_ENDPOINT ??
        // Default is a dev environment service. Production config is set in netlify.toml
        'https://q593tsh59e.execute-api.us-east-2.amazonaws.com'
};
//# sourceMappingURL=env.js.map